import { Typography, Box, useTheme } from "@mui/material";
import React from "react";

const Header = ({ title, subtitle, button }) => {
  const theme = useTheme();
  return (
    <Box>
      <Typography
        variant="h2"
        color={theme.palette.secondary[100]}
        fontWeight="bold"
        sx={{ mb: "5px" }}
        className="flex justify-between"
      >
        {title}
        {button}
      </Typography>
      <Typography variant="h5" color={theme.palette.secondary[300]}>
        {subtitle}
      </Typography>
      {/* add button to the end */}
    </Box>
  );
};

export default Header;
